(function ($){
    let product_details = $('.product-details');
    let pa_color_selected = $('#pa_color option:selected').val();

    $('body').on('click', '.variations__colors-list-item .product-color-swatch', function (){
        let that = $(this),
            val = that.attr('data-value'),
            product_attr = that.attr('data-product-attr'),
            container = that.parents('.variations__colors'),
            attr_name = container.find('.variations__selected-attr-name'),
            select = container.find('select'),
            option_selected = select.find('option[value="' + val +'"]'),
            option_selected_name = option_selected.text();

        // select option
        select.find('option').removeAttr('selected');
        select.find('option[value="' + val +'"]').prop('selected', 'selected');
        select.val(val).trigger('change');

        // button actions
        container.find('.product-color-swatch').removeClass('active');
        that.addClass('active');

        // change name in title
        attr_name.text(option_selected_name);

        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search)
            searchParams.set(product_attr, val);
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
    });

    // set default color if choice
    $('.variations__colors-list-item .product-color-swatch[data-value="'+ pa_color_selected +'"]').trigger('click');

    $(document).on('found_variation', 'form.variations_form', function(event, variation) {
        if (variation && variation.price_html) {
            $('.product-detail-price__price-wrapper').html(variation.price_html);
        }
    });
    
    //fallback
    $(document).on('reset_data', 'form.variations_form', function() {
        const $defaultPrice = $('.hidden-default-price').html();
        if ($defaultPrice) {
            $('.product-detail-price__price-wrapper').html($defaultPrice);
        }
    });
}(jQuery));


